import { InlineNotification } from '@carbon/react';
import style from './related-well-files-deprecation-notice.module.scss';

// Read-only during deprecation: existing files stay visible while new uploads
// move to Related Items. Import/delete controls were retired with the feature.
export const DEPRECATION_NOTICE =
  "Related Well Files is on a path to deprecation. Please use the new 'Related Items' feature to add new documents going forward. The existing files under the Related Well Files will be migrated to the new Related Items feature — no user action required.";

export const RelatedWellFilesDeprecationNotice = () => (
  <InlineNotification
    kind="info"
    lowContrast
    hideCloseButton
    title="Deprecation Notice"
    subtitle={DEPRECATION_NOTICE}
    className={style.deprecationBanner}
  />
);
